import { bootstrapApplication } from '@angular/platform-browser';
import { init, browserTracingIntegration, replayIntegration } from '@sentry/angular';
import { initializeApp } from 'firebase/app';
import { environment } from '@env/environment';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { initTracing } from './app/tracing';

initTracing()

initializeApp(environment.firebaseConfig);

init({
  dsn: 'https://6c8ca7bed683bcc1f76d1abffc0a2a86@o4509292325044224.ingest.us.sentry.io/4509398488907776',
  sendDefaultPii: true,
  integrations: [
    browserTracingIntegration(),
    replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    }),
  ],
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0
});

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
